var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfferReleased(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 99,
    viewBox: "0 0 105 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4383_15254)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 14,
    width: 49.5361,
    height: 49.5361,
    rx: 7.86288,
    fill: "#AD47FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4805 33.6084C48.4805 33.6084 49.0374 34.1653 49.5944 35.2792C49.5944 35.2792 51.3635 32.4945 52.9361 31.9375",
    stroke: "white",
    strokeWidth: 1.67086,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9251 28.0455C40.142 27.9277 37.9919 28.2483 37.9919 28.2483C36.6342 28.3454 34.0323 29.1066 34.0323 33.5518C34.0323 37.9593 34.0035 43.3929 34.0323 45.559C34.0323 46.8825 34.8517 49.9694 37.6879 50.1349C41.1353 50.336 47.3449 50.3788 50.194 50.1349C50.9567 50.0919 53.4958 49.4931 53.8172 46.7305C54.1501 43.8686 54.0838 41.8796 54.0838 41.4062",
    stroke: "white",
    strokeWidth: 1.67086,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2982 33.6086C56.2982 36.6846 53.8023 39.1782 50.7233 39.1782C47.6444 39.1782 45.1484 36.6846 45.1484 33.6086C45.1484 30.5326 47.6444 28.0391 50.7233 28.0391C53.8023 28.0391 56.2982 30.5326 56.2982 33.6086Z",
    stroke: "white",
    strokeWidth: 1.67086,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5703 40.291H44.0259",
    stroke: "white",
    strokeWidth: 1.67086,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5703 44.7461H48.4815",
    stroke: "white",
    strokeWidth: 1.67086,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4383_15254",
    x: -14.5967,
    y: -20.5967,
    width: 118.728,
    height: 118.728,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.2983
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4383_15254"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4383_15254",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferReleased);
export default __webpack_public_path__ + "static/media/OfferReleased.c79c91dd82d6154eb145a59893b818f5.svg";
export { ForwardRef as ReactComponent };